import React from 'react';
import { Element } from 'react-scroll';
import ProductCard from '@components/ProductCard';
import { useStyles } from './styles';

const SubMenuGroup = ({ section, name }) => {
  const classes = useStyles();

  return (
    <div key={section.name} id={name} className={classes.container}>
      <Element name={section.name}>
        <h2 className={classes.title}>{name}</h2>
      </Element>
      {section.map(product => (
        <ProductCard key={product.id} product={product} />
      ))}
    </div>
  );
};

export default SubMenuGroup;
